import $ from "jQuery";
import { onWindowResize } from "../utilities";
// import * as R from "ramda";
import * as util from "../utilities";

let closeMenuOnEscape = e => {
  if (e.which == "27") {
    // 27 is the escape key
    closeMenu();
  }
};

let openMenu = () => {
  $(".main-nav__toggler")
    .attr("tabindex", -1)
    .blur();
  $(".main-nav__close").attr("tabindex", 0);
  $("html").addClass("pgs-noscroll");
  // Removing the prohibition on transitions (implemented to prevent flash of unwanted transitions on breakpoint change)
  $(".main-nav__menu").removeClass("pgs-no-transition");
  $(".main-nav__menu").addClass("main-nav__menu--is-open");
  $(".main-nav__toggler")
    .addClass("js-is-active")
    .off("click", openMenu);
  $(".main-nav__close").addClass("js-is-active");
  $(".main-nav__close").on("click keypress", e => {
    util.ifEnterOrSpaceKeyOrClick(e, closeMenu);
  });
  util.onWindowResize(closeMenu);
  $(document).on("keydown", closeMenuOnEscape);
};

let closeMenu = () => {
  $("html").removeClass("pgs-noscroll");
  $(".main-nav__menu").removeClass("main-nav__menu--is-open");
  $(".main-nav__toggler")
    .attr("tabindex", 0)
    .removeClass("js-is-active")
    .off("click", closeMenu)
    .on("click", openMenu);
  $(".main-nav__close")
    .removeClass("js-is-active")
    .attr("tabindex", -1);

  $(window).off("resize", closeMenu);
  $(document).off("keydown", closeMenuOnEscape);
  // Adding a prohibition on transitions to prevent flash of unwanted transitions on breakpoint change. I'm using setTimeout to give time for transitions to finish.
  setTimeout(() => {
    $(".main-nav__menu").addClass("pgs-no-transition");
  }, 1000);
};

let initMenu = () => {
  $(".main-nav__toggler").on("click keypress", e => {
    util.ifEnterOrSpaceKeyOrClick(e, openMenu);
  });
};

// export let navigationToggle = R.compose(closeMenu);
export let navigationToggle = initMenu;